export default __webpack_public_path__ + "ea04d64dc7cf8ffe00c6d5843425067e.wav";